import { ButtonHTMLAttributes, ReactNode } from 'react';

interface NavButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  contracted: boolean;
  icon: ReactNode;
  label: string;
  selected: boolean;
}

export const NavButton = ({
  contracted,
  icon,
  label,
  selected,
  ...props
}: NavButtonProps) => (
  <button
    data-slot="tooltip-trigger"
    className={`inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:cursor-pointer h-9 py-2 has-[>svg]:px-3 transition-all duration-200 justify-start gap-3 px-3 ${
      selected
        ? 'bg-primary text-primary-foreground hover:bg-primary/90'
        : 'bg-transparent hover:bg-accent dark:hover:bg-accent/50 hover:text-accent-foreground'
    } ${contracted ? 'w-fit' : 'w-full'}`}
    data-state="delayed-open"
    {...props}
  >
    {icon}
    {!contracted && <span className="truncate">{label}</span>}
  </button>
);
